<template>
  <div class="relative w-full">
    <tutorial-start :show="isCurrent(1)" @next="next" @skip="leave" />
    <clench-fingers1 :show="isCurrent(2)" @next="next" @skip="leave" />
    <clench-fingers2 :show="isCurrent(3)" @next="next" @skip="leave" />
    <hand-raise-ready :show="isCurrent(4)" @next="next" @skip="leave" />
    <hand-raise-right :show="isCurrent(5)" @next="next" @skip="leave" />
    <hand-raise-left :show="isCurrent(6)" @next="next" @skip="leave" />
    <feet-pos :show="isCurrent(7)" @next="next" @skip="leave" />
  </div>
</template>

<script>
import page from '@/mixins/page';
import handleArmDetection from '@/mixins/arm-detection';
import leave from '@/mixins/leave';
import audioPlayer from '@/mixins/audio-player';

import TutorialStart from '../components/Tutorial/TutorialStart.vue';
import ClenchFingers1 from '../components/Tutorial/ClenchFingers1.vue';
import ClenchFingers2 from '../components/Tutorial/ClenchFingers2.vue';
import HandRaiseReady from '../components/Tutorial/HandRaiseReady.vue';
import HandRaiseRight from '../components/Tutorial/HandRaiseRight.vue';
import HandRaiseLeft from '../components/Tutorial/HandRaiseLeft.vue';
import FeetPos from '../components/Tutorial/FeetPos.vue';

export default {
  name: 'Tutorial',
  mixins: [page, handleArmDetection, leave, audioPlayer],
  components: {
    TutorialStart,
    ClenchFingers1,
    ClenchFingers2,
    HandRaiseReady,
    HandRaiseRight,
    HandRaiseLeft,
    FeetPos,
  },
  data: () => ({
    currentPageNo: 1,
  }),
  methods: {
    next() {
      const newPage = this.currentPageNo + 1;
      if (!this.lastScreen) {
        this.currentPageNo = newPage;
      } else {
        this.$events.goto('ChooseToStart');
      }
      // play audio through page 2 and 3
      if (newPage === 2) {
        this.playAudio('8_tutorial_clench');
      }
      if (newPage === 4) {
        this.playAudio('9_tutorial_control_bubbles');
      }
    },
    isCurrent(index) {
      return this.currentPageNo === index;
    },
  },
  computed: {
    lastScreen() {
      return this.currentPageNo >= 7;
    },
  },
};
</script>
